import { useTranslation } from 'react-i18next';

const ServiceHistoryModal = ({ open, onClose, history, serviceName }) => {
  const { t, i18n } = useTranslation();

  if (!open) return null;

  const sorted = [...(history || [])].sort(
    (a, b) => new Date(b.changedAt) - new Date(a.changedAt)
  );

  const formatValue = (field, value) => {
    if (field === 'price') return t('common.currency', { amount: Number(value).toLocaleString() });
    if (field === 'duration') return t('common.duration', { minutes: value });
    if (typeof value === 'boolean') return value ? t('common.active') : t('common.inactive');
    return value ?? '—';
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="max-h-[80vh] w-full max-w-lg overflow-hidden rounded-xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900">
        <div className="flex items-center justify-between border-b border-zinc-200 dark:border-zinc-800 p-5">
          <h3 className="text-lg font-medium">{t('salon.services.historyTitle', { name: serviceName })}</h3>
          <button type="button" onClick={onClose} aria-label={t('common.close')} className="text-zinc-600 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-white">
            ✕
          </button>
        </div>
        <div className="max-h-96 overflow-y-auto p-5">
          {sorted.length === 0 && (
            <p className="text-sm text-zinc-600 dark:text-zinc-500">{t('salon.services.noChanges')}</p>
          )}
          <ul className="space-y-4">
            {sorted.map((entry) => (
              <li key={entry._id} className="border-l-2 border-glow-600 pl-4 text-sm">
                <p className="text-zinc-800 dark:text-zinc-200">
                  {t('salon.services.fieldChanged', {
                    field: entry.field,
                    old: formatValue(entry.field, entry.oldValue),
                    new: formatValue(entry.field, entry.newValue),
                  })}
                </p>
                <p className="mt-1 text-xs text-zinc-600 dark:text-zinc-500">
                  {t('salon.services.changedByOn', {
                    name: entry.changedBy
                      ? `${entry.changedBy.firstName} ${entry.changedBy.lastName}`
                      : t('common.system'),
                    date: new Date(entry.changedAt).toLocaleDateString(i18n.language, {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric',
                    }),
                  })}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ServiceHistoryModal;
